/**
 * Textos (`es`) del tall «planta» de Qualitat i APPCC: lo que la App de planta dice del control de calidad en la
 * recepción (OBR-167). Cada namespace de este fichero es AUTOCONTENIDO (`planta.qualityReception`, y los que
 * añadan los otros cortes: autocontroles, no conformidades). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const plantaEs = {
  'planta.qualityReception': {
    // ── Bloque de control de calidad de una entrada ───────────────────────────────────
    title: 'Control de calidad',
    temperature: 'Temperatura (°C)',
    temperatureRequired: 'Temperatura (°C), obligatoria',
    temperaturePlaceholder: 'Por ejemplo 3,5',
    temperatureRange: 'Rango aceptable: {{range}}',
    rangeBetween: '{{min}} a {{max}} °C',
    rangeAtLeast: 'Mínimo {{min}} °C',
    rangeAtMost: 'Máximo {{max}} °C',
    signToggle: 'Cambia el signo: positivo o negativo',
    status_ok: 'Dentro del rango',
    status_low: 'Por debajo del mínimo',
    status_high: 'Por encima del máximo',
    temperatureMissing: 'Hay que anotar la temperatura.',
    temperatureUnreadable: 'Escribe una temperatura válida.',
    packaging: 'Envase',
    labeling: 'Etiquetado',
    checkOk: 'OK',
    checkKo: 'KO',
    issuesNotice: 'Algo no cuadra: {{list}}. Se registrará una no conformidad.',
    issue_temperature_out_of_range: 'temperatura fuera de rango',
    issue_packaging_ko: 'envase en mal estado',
    issue_labeling_ko: 'etiquetado incorrecto',
    decision: '¿Qué haces con el género?',
    decision_accepted: 'Acepta',
    decision_accepted_with_incident: 'Acepta con incidencia',
    decision_rejected: 'Rechaza',
    decisionMissing: 'Elige qué haces con el género.',
    rejectedHint:
      'Rechazar el género lo bloquea en las existencias: no se podrá gastar y quedará pendiente de devolver.',
    derivedNok: 'No conforme por el control',

    // ── Pantalla de recepción ─────────────────────────────────────────────────────────
    lineNeedsQuality: 'Falta el control',
    qualityMissingSummary: 'Falta la temperatura o qué haces con el género en alguna entrada.',
    supplierNotApproved: 'Este proveedor no está homologado.',
    supplierSuspended: 'Este proveedor está suspendido.',
    supplierWarningHint: 'Puedes recibir el género igualmente: la recepción queda registrada y se revisará.',

    // ── Detalle de la recepción ───────────────────────────────────────────────────────
    detailTemperature: 'Temperatura: {{value}} °C',
    detailPackaging: 'Envase: {{status}}',
    detailLabeling: 'Etiquetado: {{status}}',
    detailDecision: 'Decisión: {{decision}}',
  },

  'planta.selfChecks': {
    // ── Tarjeta del inicio de Órdenes y pantalla de Calidad ────────────────────────────
    title: 'Calidad',
    cardTitle: 'Autocontroles de hoy',
    cardPending_one: '{{count}} autocontrol pendiente',
    cardPending_other: '{{count}} autocontroles pendientes',
    cardAllDone: 'Todos los autocontroles están hechos.',
    cardSeeAll: 'Ver todo',
    cardOpen: 'Haz el autocontrol: {{name}}',
    dueSection: 'Pendientes',
    doneSection: 'Hechos',
    noneDue: 'Todo hecho por ahora.',
    noTemplates: 'El obrador todavía no tiene autocontroles. Se configuran en el BackOffice, en Calidad.',
    duePeriod_daily: 'Hoy',
    duePeriod_weekly: 'Esta semana',
    duePeriod_monthly: 'Este mes',
    kind_cleaning: 'Limpieza y desinfección',
    kind_temperature: 'Temperaturas',
    kind_pests: 'Control de plagas',
    kind_custom: 'Otros',
    frequency_daily: 'Diaria',
    frequency_weekly: 'Semanal',
    frequency_monthly: 'Mensual',
    resultOk: 'OK',
    resultKo: 'KO',
    doneAt: 'Hecho a las {{time}}',
    pendingSync: 'Pendiente de enviar',
    webUnsupported: 'Los autocontroles se hacen desde la app del móvil.',

    // ── Rellenar un autocontrol ───────────────────────────────────────────────────────
    instructionsTitle: 'Cómo se hace',
    markAllOk: 'Marca OK los que faltan',
    checkOk: 'OK',
    checkKo: 'KO',
    requiredTag: 'obligatorio',
    fieldMissing: 'Falta rellenar este campo.',
    numberPlaceholder: 'Por ejemplo 3,5',
    numberUnreadable: 'Escribe un número válido.',
    numberRange: 'Rango aceptable: {{range}}',
    rangeBetween: '{{min}} a {{max}}{{unit}}',
    rangeAtLeast: 'Mínimo {{min}}{{unit}}',
    rangeAtMost: 'Máximo {{max}}{{unit}}',
    signToggle: 'Cambia el signo: positivo o negativo',
    status_in_range: 'Dentro del rango',
    status_out_of_range: 'Fuera de rango',
    textPlaceholder: 'Escríbelo aquí',
    photoTake: 'Haz una foto',
    photoRetake: 'Vuelve a hacerla',
    photoRemove: 'Quítala',
    photoAttached: 'Foto adjuntada',
    photoPendingUpload: 'Se subirá cuando haya conexión.',
    photoPermissionDenied: 'Hace falta dar permiso para usar la cámara.',
    recordPhoto: 'Foto del autocontrol (opcional)',
    notes: 'Notas del autocontrol (opcional)',
    notesPlaceholder: 'Cualquier cosa que convenga dejar escrita',
    issuesNotice: 'Algo no cuadra: {{list}}. Se abrirá una no conformidad.',
    issueItemKo: '{{label}} en KO',
    issueItemRange: '{{label}} fuera de rango ({{value}}{{unit}})',
    missingSummary: 'Falta rellenar: {{list}}.',
    save: 'Guardar',
    saving: 'Guardando…',
    saveFailed: 'No se ha podido guardar. Vuelve a intentarlo.',

    // ── Guardado, ya hecho, no encontrado ─────────────────────────────────────────────
    saved: 'Autocontrol guardado',
    savedKo: 'Guardado. Se abrirá una no conformidad cuando llegue al servidor.',
    savedHint: 'Sin conexión, se enviará solo cuando la vuelvas a tener.',
    nextCheck: 'Siguiente autocontrol',
    nextCheckName: 'Pendiente: {{name}}',
    backToList: 'Volver a Calidad',
    alreadyDoneTitle: 'Ya está hecho',
    alreadyDoneBody: 'Este autocontrol ya consta como hecho en este periodo ({{result}}).',
    notFoundTitle: 'No se ha encontrado el autocontrol',
    notFoundBody: 'Quizá se ha dado de baja. Vuelve a la lista.',
  },

  'planta.nonConformities': {
    reportCta: 'Comunica una no conformidad',
    title: 'Comunica una no conformidad',
    intro: 'Explica lo que has visto. Queda registrado ahora, también sin conexión.',
    description: '¿Qué ha pasado?',
    descriptionPlaceholder: 'Por ejemplo: caja de leche rota en el muelle',
    descriptionMissing: 'Explica qué ha pasado.',
    relatedTitle: 'Relacionada con (opcional)',
    supplier: 'Proveedor',
    article: 'Artículo',
    pickSupplier: 'Elige un proveedor',
    pickArticle: 'Elige un artículo',
    change: 'Cambia',
    clear: 'Quita',
    search: 'Busca por nombre o código',
    noMatch: 'Ningún resultado.',
    noSuppliers: 'Todavía no hay proveedores en este aparato.',
    noArticles: 'Todavía no hay artículos en este aparato.',
    close: 'Cierra',
    photo: 'Foto (opcional)',
    photoTake: 'Haz una foto',
    photoRetake: 'Vuelve a hacerla',
    photoRemove: 'Quítala',
    photoAttached: 'Foto adjuntada',
    photoPendingUpload: 'Se subirá cuando haya conexión.',
    photoPermissionDenied: 'Hace falta dar permiso para usar la cámara.',
    save: 'Comunicar',
    saving: 'Enviando…',
    saveFailed: 'No se ha podido comunicar. Vuelve a intentarlo.',
    saved: 'No conformidad comunicada',
    savedBody: 'Queda registrada y se revisará. Recibirá su código NC cuando llegue al servidor.',
    reportAnother: 'Comunica otra',
    backToQuality: 'Volver a Calidad',
    historyTitle: 'Comunicadas desde este aparato',
    historyEmpty: 'Todavía no has comunicado ninguna.',
    codePending: 'Pendiente de enviar',
    statusRejected: 'No se ha podido enviar',
    withPhoto: 'Con foto',
    webUnsupported: 'Las no conformidades se comunican desde la app del móvil.',
  },
} as const;
